import {
  FaQuestionCircle,
  FaMobileAlt,
  FaChalkboardTeacher,
  FaServer,
} from "react-icons/fa";
import { BiMemoryCard } from "react-icons/bi";
import { TbHandClick } from "react-icons/tb";

export const TROUBLESHOOT_STEPS = [
  {
    type: "LOGIN_ISSUE",
    subType: "TEACHER_ACTIVE",
    title: "Teacher is active?",
    icon: <FaChalkboardTeacher />,
    resolve: [],
  },
  {
    type: "LOGIN_ISSUE",
    subType: "GET_OTP",
    title: "Last OTP Generated",
    icon: <FaMobileAlt />,
    resolve: [
      {
        type: "TEXT",
        value:
          "Please ask user to generate an OTP through the teacher app. Once OTP is generated, click on the 'Get OTP' button to retrieve the latest generated OTP.",
      },
      {
        type: "TRIGGER",
        value: "Get OTP",
      },
    ],
  },
  {
    type: "RESOURCE_NOT_FOUND",
    subType: "NAS_BOX",
    title: "Is NAS Ok?",
    icon: <FaServer />,
    resolve: [
      {
        type: "TEXT_ONLINE",
        value: "Reboot NAS to trigger resource downloading",
      },
      {
        type: "TEXT_OFFLINE",
        value: "Turn on NAS, and wait while it download pending resources",
      },
    ],
  },
  {
    type: "RESOURCE_NOT_FOUND",
    subType: "SD_CARD",
    title: "Is device Ok?",
    icon: <BiMemoryCard />,
    resolve: [
      {
        type: "TEXT_FORMAT",
        value:
          "SD card is corrupt, please format, and re-run 1-click to download resources.",
      },
      {
        type: "TEXT_STORAGE_PERMISSION",
        value:
          "Not enough space and external storage permission not provided. Provide permission and trigger 1-click to delete pending resources",
      },
      {
        type: "RED_RESOURCES_TRIGGER",
        value: "User has red resources, and running 1-click can help",
      },
      {
        type: "TRIGGER",
        value: "Run 1-click",
      },
    ],
  },
  {
    type: "RESOURCE_NOT_FOUND",
    subType: "TEACHER_FACING_ISSUE",
    title: "Teacher facing issue with One-click module?",
    icon: <FaQuestionCircle />,
    resolve: [
      {
        type: "TRIGGER",
        value: "Run 1-click",
      },
    ],
  },
  {
    type: "RESOURCE_NOT_FOUND",
    subType: "TEACHER_ONE_CLICK",
    title: "Teacher require One-click?",
    icon: <TbHandClick />,
    resolve: [
      {
        type: "TRIGGER",
        value: "Run 1-click",
      },
    ],
  },
  {
    type: "RESOURCE_NOT_FOUND",
    subType: "MAPPING_CHANGES",
    title: "Subject, class or student allocation has been performed?",
    icon: <FaServer />,
    resolve: [
      {
        type: "TRIGGER",
        value: "Run 1-click",
      },
    ],
  },
];

export const TROUBLESHOOT_OPTIONS = [
  {
    name: "Resource not downloading",
    type: "RESOURCE_NOT_FOUND",
  },
  {
    name: "Not able to login",
    type: "LOGIN_ISSUE",
  },
  {
    name: "Others",
    type: "OTHERS",
  },
];

export const TROUBLESHOOT_CONSTANTS = {
  SD_CARD: "SD_CARD",
  NAS_CARD: "NAS_CARD",
  TEACHER_ONE_CLICK: "TEACHER_ONE_CLICK",
};

export const SHOW_TROUBLESHOOT_TO_ROLES_IDS = [1, 73, 74, 75];
